import mixins from "../../mixins";

const generateUID = mixins.generateUID.methods.generateUID;

export default {
  isEditMode: true,
  pageProperties: {
    "pages": [
      {
        "pageName": "home",
        "pageId": 1,
        "sections": [
          {
            "sectionId": "a0us1n",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              {
                fieldId: "vas2fp",
                fieldType: "multi-campaign"
              }
            ]
          }
        ]
      },
      { // ColgateUltra2023 campaign
        "pageName": "ColgateUltra2023",
        "pageId": 28972,
        "isPublic": true,
        "sections": [
          {
            "sectionId": "orbg8s",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              {
                "fieldType": "refresh-token",
                "fieldId": "ij3433"
              },
              {
                fieldId: "dte-003",
                fieldType: "dataLayer-event",
                properties: {
                  eventName: "PageView",
                  fbEvent: "PageView"
                }
              },
              {
                "fieldType": "key-visual",
                "fieldId": "296eg1",
                "properties": {
                  "grid": {
                    "columns": "12"
                  },
                  "styles": {
                    "margin": '2% 0 0 0',
                    "padding": '0'
                  },
                  "imageStyles":{
                    'border-radius': '16px'
                  },
                  "noContainer": false,
                  "addRow": true,
                  "desktopImageUrl": "/assets/campaigns/ColgateUltra2023/key-visual.png",
                  "mobileImageUrl": "/assets/campaigns/ColgateUltra2023/key-visual.png"
                }
              },
              {
                "fieldType": "participa",
                "fieldId": "acsh315",
                "properties": {
                  "grid": {
                    "columns": "12"
                  },
                  "color": "#DB0811",
                  "buttonClass": "btn-red-gradient",
                  "nextPage": "ColgateUltra2023/InscrieBonul",
                  "campaign": "ColgateUltra2023",
                  "borderColor":"rgba(86, 22, 23, 0.25)",
                  "steps": [
                    {
                      "title": "Pasul 1",
                      "text": "Cumpara produse Colgate Max Ultra White.",
                      "image": "select"
                    },
                    {
                      "title": "Pasul 2",
                      "text": "Incarca bonul fiscal",
                      "image": "receipt"
                    },
                    {
                      "title": "Pasul 3",
                      "text": "Inregistreaza-te",
                      "image": "register"
                    },
                    {
                      "title": "Pasul 4",
                      "text": "Castiga premii!",
                      "image": "reward"
                    }
                  ]
                }
              }
            ]
          }
        ]
      },
      { // Upload receipt
        "pageName": "ColgateUltra2023/InscrieBonul",
        "pageId": 22345,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "sectionId": "fu30zq",
            "fields": [
              {
                "fieldType": "step-counter",
                "fieldId": "tj4j49",
                "properties": {
                  "activeIndex": 1,
                  "colorSchema": "#DB0811",
                  "stepShadow": "#E3D3D3",
                  "startGradient": "#E3D3D3",
                  "endGradient": "radial-gradient(173.75% 424.92% at 50% 50.57%, #DB0811 0%, #FFC6CF 44.85%, #A26971 100%)",
                  "completedGradient": "radial-gradient(173.75% 424.92% at 50% 50.57%, #DB0811 0%, #FFC6CF 44.85%, #A26971 100%), #ffffff",
                  "steps": [
                    {
                      "title": "Cumpara produse Colgate Max Ultra White",
                      "page": "Cumpără Ajax si/sau Axion"
                    },
                    {
                      "title": "Incarca bonul fiscal",
                      "page": "ColgateUltra2023/Inregistreaza"
                    },
                    {
                      "title": "Inregistreaza-te",
                      "page": "ColgateUltra2023/Inregistreaza"
                    },
                    {
                      "title": "Castiga premii!",
                      "page": "ColgateUltra2023/Inregistreaza"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1>Incarca bonul fiscal/factura</h1>",
                  styles: {
                    "font-family": 'Plus Jakarta Sans;',
                    "color": "#0E1B17"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "La acest pas, te rugăm să încarci dovada achiziționării produselor Colgate Max Ultra White.",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '20px;',
                    "color": "#00291C"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basg325",
                "properties": {
                  "text": "Te rugam sa faci o poza a intregului/intregii bon fiscal/facturi sau sa incarci un PDF al bonului fiscal/facturii",
                  "grid": {
                    "marginBottom": "40px"
                  },
                  styles: {
                    "font-weight": '400;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '14px;',
                    "line-height": "20px;",
                    "color": "#00291C"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 0,
                    "justifyContent": "center",
                    "maxWidth": "1230px"
                  },
                  "fields": [
                    {
                      "fieldType": "receipt-processor",
                      "fieldId": "klvakj",
                      "properties": {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca bonul fiscal/factura.</span>.<br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        "colorSchema": "#244C9D",
                        "fileUploadColor": "rgba(0, 0, 0, 0.5)",
                        "borderColor": "#244C9D",
                        "buttonClass": "btn-red-gradient-secondary",
                        "inputBacgroundColor":"#F0EEF1",
                        "grid": {
                          "columns": 5,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "successAction": {
                          "fn": "goToPage",
                          "params": "ColgateUltra2023/Inregistreaza"
                        },
                        "campaignId": "colgateultra-mb-2023",
                        "phrases": [
                          "Chitanta dvs. este acum incarcata si procesata.",
                          "Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.",
                          "Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou."
                        ],
                        "cornerDetectionPhrases": [
                          "Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.",
                          "Te rugam sa potrivesti bonul in cadran.",
                          "Puteti sterge informatii private cu instrumentul de stergere."
                        ],
                        "eraseColor": "#ffffff",
                        "eraseSize": 12,
                        "cropColor": "#F27B26",
                        "cropBackground": "rgba(0,0,0,0.6)",
                        "cropTitle": "Decupeaza",
                        "eraseTitle": "Acopera",
                        "dragTitle": "Deplaseaza imaginea",
                        "zoomInTitle": "Mareste",
                        "zoomOutTitle": "Micsoreaza",
                        "selectImageTitle": "Select an Image",
                        "selectAnotherTitle": "Select Another",
                        "controlsBackground": "#244C9D",
                        "backgroundColorBtn": "black",
                        "textColor": "#141414"
                      }
                    },
                    {
                      "fieldType": "empty-bucket",
                      "properties": {
                        "grid": {
                          "columns": 7
                        },
                        "fields": [
                          {
                            "fieldType": "receipt-information",
                            "fieldId": "5mq1p6",
                            "properties": {
                              "grid": {
                                "alignItems": "center",
                                "justifyContent": "center",
                                "columns": "12"
                              },
                              "styles": {
                                "text-align": "left"
                              },
                              "color": "#DB0811",
                              "textColor": "#0E1B17",
                              "descriptionTextColor":"#00291C",
                              "descriptionText": "Nu se accepta bonuri sau facturi pliate/indoite sau scanate",
                              "receiptImage": "receipt33",
                              "receiptIsSvg": true,
                              "steps": [
                                {
                                  "text": "Nume Retailer/ Magazin",
                                  "label": "A"
                                },
                                {
                                  "text": "Produsele care intra in promotie si pretul lor",
                                  "label": "B"
                                },
                                {
                                  "text": "Suma totala a bonului/facturii in LEI/RON",
                                  "label": "C"
                                },
                                {
                                  "text": "Data si ora de pe bon sau de pe factura",
                                  "label": "D"
                                },
                                {
                                  "text": "Nr bonului fiscal/facturii",
                                  "label": "E"
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "bsbsd35",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "receipt-image-information"
              }
            ]
          },
          {
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "40px"
            },
            "container": true,
            "buttonsWrap": true,
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm1",
                "properties": {
                  "grid": {
                    "columns": "0"
                  },
                  "addClass": "btn-link",
                  "text": "Inapoi",
                  "disabled": false,
                  "styles": {
                    "position": "absolute;",
                    "left": 0
                  },
                  "action": {
                    "fn": "goToPage",
                    "params": "ColgateUltra2023"
                  }
                }
              },
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "Continua",
                  "addClass": "btn-red-gradient",
                  "shouldCheckCrop": true,
                  "requires": ["klvakj"],
                  "action": {
                    "fn": "sendReceipt",
                    "params": ""
                  }
                }
              }
            ]
          }
        ]
      },
      { // Register form
        "pageName": "ColgateUltra2023/Inregistreaza",
        "pageId": 634553232,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12
            },
            "container": true,
            "fields": [
              {
                "fieldType": "step-counter",
                "fieldId": "tj4j49",
                "properties": {
                  "activeIndex": 2,
                  "colorSchema": "#DB0811",
                  "stepShadow": "#E3D3D3",
                  "startGradient": "#E3D3D3",
                  "endGradient": "radial-gradient(173.75% 424.92% at 50% 50.57%, #DB0811 0%, #FFC6CF 44.85%, #A26971 100%)",
                  "completedGradient": "radial-gradient(173.75% 424.92% at 50% 50.57%, #DB0811 0%, #FFC6CF 44.85%, #A26971 100%), #ffffff",
                  "steps": [
                    {
                      "title": "Cumpara produse Colgate Max Ultra White",
                      "page": "Cumpără Ajax si/sau Axion"
                    },
                    {
                      "title": "Incarca bonul fiscal",
                      "page": "ColgateUltra2023/Inregistreaza"
                    },
                    {
                      "title": "Inregistreaza-te",
                      "page": "ColgateUltra2023/Inregistreaza"
                    },
                    {
                      "title": "Castiga premii!",
                      "page": "ColgateUltra2023/Inregistreaza"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "fckzg7",
                "properties": {
                  "text": "<h1>Formular de inscriere</h1>",
                  styles:{
                      "color":"#141414"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "ci88zt",
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 4,
              "marginTop": "40px"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "form-component",
                "fieldId": "j765n4b",
                "properties": {
                  "styles": {
                    "margin": "0",
                    "justifyContent": "center",
                    "--maxWidth": "545px",
                    "--backgroundColor": "#F0EEF1"
                  },
                  "grid": {
                    "alignItems": "center",
                    "columns": "0",
                    "justifyContent": "center"
                  },
                  "requires": [
                    "1"
                  ],
                  "successAction": {
                    "fn": "goToPage",
                    "params": "ColgateUltra2023/Multumim"
                  },
                  "endpoint": "/register",
                  "fields": [
                    {
                      "fieldId": "b4baqs",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "surname",
                        "autocomplete": "no",
                        "label": "Prenume",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      "fieldId": "gofije",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "name",
                        "autocomplete": "no",
                        "label": "Nume",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf9",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "email",
                        "label": "E-mail",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|email",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      "fieldId": "vake42c",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "mobile",
                        "label": "Numar de telefon",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|phoneNumber",
                        "grid": {
                          "columns": 12
                        },
                        "autocomplete": "nope",
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      "fieldId": "ko3h1sz",
                      "fieldType": "paragraph",
                      "properties": {
                        "text": "<b>Atentie!</b> In cazul introducerii unei adrese de e-mail gresite, daca esti declarat castigator, nu vei primi premiul castigat, conform Articolelor 4.3, 4.4, 8.7 si 8.8 din Regulamentul campaniei.",
                        "grid": {
                          "columns": "12",
                          "marginTop": "35px"
                        },
                        "classes": ['disclaimer'],
                        "styles":{
                          "color": "#2E2E2E !important"
                        }
                      }
                    },
                    {
                      "fieldId": "wgc3j7",
                      "fieldType": "checkbox",
                      "properties": {
                        "name": "terms",
                        "validation": {
                          "required": {
                            "allowFalse": false
                          }
                        },
                        "validationName": "Termenii si conditiile sunt necesare",
                        "grid": {
                          "columns": "12",
                          "paddingTop": "10px"
                        },
                        "styles": {
                          "margin-top": "30px",
                          "--color": "#2E2E2E",
                          "--checkedCheckbox": "url(/assets/icons/form/checked_checkbox.svg)",
                          "--uncheckedCheckbox": "url(/assets/icons/form/unchecked_checkbox.svg)"
                        },
                        "label": `Confirm ca am peste 18 ani. Confirm <a href="/files/ColgateUltra2023Regulament.pdf" target="_blank"><u>termenii si conditiile</u></a> si <a href="https://www.colgatepalmolive.ro/legal-privacy-policy/privacy-policy" target="_blank"><u>politica de confidentialitate</u></a></div>.`
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "yh453gg4",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "120px"
            },
            "container": true,
            "buttonsWrap": true,
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm1",
                "properties": {
                  "grid": {
                    "columns": "0"
                  },
                  "addClass": "btn-link",
                  "text": "Inapoi",
                  "disabled": false,
                  "styles": {
                    "position": "absolute;",
                    "left": 0
                  },
                  "action": {
                    "fn": "goToPage",
                    "params": "ColgateUltra2023/InscrieBonul"
                  }
                }
              },
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "TRIMITE",
                  "disabled": false,
                  "addClass": "btn-red-gradient",
                  "action": {
                    "fn": "sendForm",
                    "params": "j765n4b"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Winner form page
        "pageName": "ColgateUltra2023/WinnerPage",
        "isPublic": true,
        "pageId": 634553,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "headerWrap": true,
            "sectionId": "basb782",
            "fields": [
              {
                "fieldType": "query-string-to-state",
                "fieldId": "vasv24",
                properties: {
                  variables: [
                    {
                      query: "customerToken",
                      state: "customerToken"
                    }
                  ]
                }
              },
              {
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "receiptToken",
                      state: "receiptToken"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1 style=' color= #141414; '>Formular pentru Castigator</h1>"
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Completeaza-ti adresa in formularul de mai jos pentru a-ti putea trimite premiul",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '20px;',
                    "color": "#141414"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "ci88zt",
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 4,
              "marginTop": "50px"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "form-component",
                "fieldId": "j765n4b",
                "properties": {
                  "styles": {
                    "margin": "0",
                    "justifyContent": "center",
                    "--backgroundColor": "#F0EEF1"
                  },
                  "grid": {
                    "alignItems": "center",
                    "columns": "0",
                    "justifyContent": "center"
                  },
                  "requires": [
                    "1"
                  ],
                  "successAction": {
                    "fn": "goToPage",
                    "params": "ColgateUltra2023/WinnerThankYou"
                  },
                  "endpoint": "/winnerRegister",
                  "fields": [
                    {
                      "fieldId": "b4baqs",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "surname",
                        "autocomplete": "no",
                        "label": "Prenume",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      "fieldId": "gofije",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "name",
                        "autocomplete": "no",
                        "label": "Nume",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf9",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "email",
                        "label": "E-mail",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|email",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      "fieldId": "vake42c",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "mobile",
                        "label": "Numar de telefon",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|phoneNumber",
                        "grid": {
                          "columns": 12
                        },
                        "autocomplete": "nope",
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf8",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "address",
                        "label": "Adresa",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "requiredAdress|adress",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      "fieldId": "ko3h1sz",
                      "fieldType": "paragraph",
                      "properties": {
                        "text": "*strada, numar, bloc, scara, apartament",
                        "grid": {
                          "columns": "12",
                          "marginTop": "20px;",
                          "marginBottom": "20px"
                        },
                        "classes": ['disclaimer'],
                        "styles":{
                          "color": "#2E2E2E !important"
                        }
                      }
                    }
                  ],
                  "extraFields": [
                    {
                      "fieldId": "bdsb632",
                      "fieldType": "select-input-county",
                      "properties": {
                        "name": "judet",
                        "label": "Judet",
                        "placeholder": "Judet",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "requiredJudet",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px",
                          "border-color": "#1A1A18"
                        },
                        "autocomplete": "nope"
                      }
                    },
                    {
                      "fieldId": "bask257",
                      "fieldType": "select-input-city",
                      "properties": {
                        "name": "localitate",
                        "label": "Localitate",
                        "placeholder": "Localitate",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "requiredLocal",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        },
                        "autocomplete": "nope"
                      }
                    },
                    {
                      "fieldId": "acasg235",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "postal",
                        "label": "Cod postal",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "integer|length:6",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        },
                        "autocomplete": "nope",
                        "disablePaste": true
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "yh453gg4",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "130px"
            },
            "container": true,
            "styles": {
              'justify-content': 'center'
            },
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "TRIMITE",
                  "disabled": false,
                  "addClass": "btn-red-gradient",
                  "action": {
                    "fn": "sendForm",
                    "params": "j765n4b"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Winner CNP form page
        "pageName": "ColgateUltra2023/WinnerPageCNP",
        "isPublic": true,
        "pageId": 6345531,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "headerWrap": true,
            "sectionId": "basb782",
            "fields": [
              {
                "fieldType": "query-string-to-state",
                "fieldId": "vasv24",
                properties: {
                  variables: [
                    {
                      query: "customerToken",
                      state: "customerToken"
                    }
                  ]
                }
              },
              {
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "receiptToken",
                      state: "receiptToken"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1 style=' color= #141414; '>Formular pentru Castigator</h1>"
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Completeaza-ti adresa in formularul de mai jos pentru a-ti putea trimite premiul",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '20px;',
                    "color": "#141414"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "ci88zt",
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 4,
              "marginTop": "50px"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "form-component",
                "fieldId": "j765n4b",
                "properties": {
                  "styles": {
                    "margin": "0",
                    "justifyContent": "center",
                    "--backgroundColor": "#F0EEF1"
                  },
                  "grid": {
                    "alignItems": "center",
                    "columns": "0",
                    "justifyContent": "center"
                  },
                  "requires": [
                    "1"
                  ],
                  "successAction": {
                    "fn": "goToPage",
                    "params": "ColgateUltra2023/WinnerThankYou"
                  },
                  "endpoint": "/winnerRegister",
                  "fields": [
                    {
                      "fieldId": "b4baqs",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "surname",
                        "autocomplete": "no",
                        "label": "Prenume",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      "fieldId": "gofije",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "name",
                        "autocomplete": "no",
                        "label": "Nume",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf9",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "email",
                        "label": "E-mail",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|email",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      "fieldId": "vake42c",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "mobile",
                        "label": "Numar de telefon",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|phoneNumber",
                        "grid": {
                          "columns": 12
                        },
                        "autocomplete": "nope",
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf8",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "address",
                        "label": "Adresa",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "requiredAdress|adress",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      "fieldId": "ko3h1sz",
                      "fieldType": "paragraph",
                      "properties": {
                        "text": "*strada, numar, bloc, scara, apartament",
                        "grid": {
                          "columns": "12",
                          "marginTop": "20px;",
                          "marginBottom": "20px"
                        },
                        "classes": ['disclaimer'],
                        "styles":{
                          "color": "#2E2E2E !important"
                        }
                      }
                    }
                  ],
                  "extraFields": [
                    {
                      "fieldId": "bdsb632",
                      "fieldType": "select-input-county",
                      "properties": {
                        "name": "judet",
                        "label": "Judet",
                        "placeholder": "Judet",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "requiredJudet",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px",
                          "border-color": "#1A1A18"
                        },
                        "autocomplete": "nope"
                      }
                    },
                    {
                      "fieldId": "bask257",
                      "fieldType": "select-input-city",
                      "properties": {
                        "name": "localitate",
                        "label": "Localitate",
                        "placeholder": "Localitate",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "requiredLocal",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        },
                        "autocomplete": "nope"
                      }
                    },
                    {
                      "fieldId": "acasg235",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "postal",
                        "label": "Cod postal",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "integer|length:6",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        },
                        "autocomplete": "nope",
                        "disablePaste": true
                      }
                    },
                    {
                      "fieldId": "bsdy4362",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "cnp",
                        "autocomplete": "no",
                        "label": "CNP",
                        "placeholder": "",
                        "text": "",
                        "validation": "required|integer|length:13",
                        "color": "#2E2E2E",
                        "grid": {
                          "alignItems": "center;",
                          "justifyContent": "center;",
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      "fieldId": "bsadbsd325",
                      "fieldType": "checkbox",
                      "properties": {
                        "name": "cnpConfirm",
                        "validation": {
                          "required": {
                            "allowFalse": false
                          }
                        },
                        "validationName": "terms",
                        "grid": {
                          "columns": "12",
                          "paddingTop": "10px"
                        },
                        "styles": {
                          "margin-top": "30px",
                          "--color": "#2E2E2E",
                          "--checkedCheckbox": "url(/assets/icons/form/checked_checkbox.svg)",
                          "--uncheckedCheckbox": "url(/assets/icons/form/unchecked_checkbox.svg)"
                        },
                        "label": `Declar ca acest CNP imi apartine, cunoscand faptul ca orice declaratie falsa este sanctionata conform legii penale romane.`
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "yh453gg4",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "130px"
            },
            "container": true,
            "styles": {
              'justify-content': 'center'
            },
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "TRIMITE",
                  "disabled": false,
                  "addClass": "btn-red-gradient",
                  "action": {
                    "fn": "sendForm",
                    "params": "j765n4b"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Winner thank you
        "pageName": "ColgateUltra2023/WinnerThankYou",
        "pageId": 99830,
        "noContainer": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "thank-you-winner",
                "fieldId": "gjd10",
                "properties": {
                  "campaign": "ColgateUltra2023",
                  "campaignName": "Campania Nationala Colgate Max White Ultra Money Back",
                  "haveActivator": false,
                  "textColor": "#141414"
                }
              }
            ]
          }
        ]
      },
      { // Receipt reupload
        "pageName": "ColgateUltra2023/receipt-reupload",
        "isPublic": true,
        "pageId": 32,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "headerWrap": true,
            "sectionId": "fu30zq",
            "fields": [
              {
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "referenceNumber",
                      state: "formData"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1>Te rugam sa incarci din nou bonul fiscal/factura</h1>",
                  styles:{
                      "color": "#0E1B17"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Bonul fiscal/factura incarcat/a anterior nu ne este complet/a sau este ilizibil.",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '20px;',
                    "color": "#00291C;"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basg325",
                "properties": {
                  "text": "Te rugam sa faci o poza a intregului/intregii bon fiscal/facturi sau sa incarci un PDF al bonului fiscal/facturii",
                  "grid": {
                    "marginBottom": "40px"
                  },
                  styles: {
                    "font-weight": '400;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '14px;',
                    "line-height": "20px;",
                    "color": "#00291C;"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 0,
                    "justifyContent": "center",
                    "maxWidth": "1230px"
                  },
                  "fields": [
                    {
                      "fieldType": "receipt-processor",
                      "fieldId": "klvakj",
                      "properties": {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca bonul fiscal/factura.</span>.<br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        "colorSchema": "#244C9D",
                        "fileUploadColor": "rgba(0, 0, 0, 0.5)",
                        "borderColor": "#244C9D",
                        "inputBacgroundColor":"#F0EEF1",
                        "buttonClass": "btn-red-gradient-secondary",
                        "grid": {
                          "columns": 5,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "successAction": {
                          "fn": "goToPage",
                          "params": "ColgateUltra2023/Multumesc"
                        },
                        "campaignId": "colgateultra-mb-2023",
                        "phrases": [
                          "Chitanta dvs. este acum incarcata si procesata.",
                          "Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.",
                          "Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou."
                        ],
                        "cornerDetectionPhrases": [
                          "Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.",
                          "Te rugam sa potrivesti bonul in cadran.",
                          "Puteti sterge informatii private cu instrumentul de stergere."
                        ],
                        "eraseColor": "#ffffff",
                        "eraseSize": 12,
                        "cropColor": "#F27B26",
                        "cropBackground": "rgba(0,0,0,0.6)",
                        "cropTitle": "Decupeaza",
                        "eraseTitle": "Acopera",
                        "dragTitle": "Deplaseaza imaginea",
                        "zoomInTitle": "Mareste",
                        "zoomOutTitle": "Micsoreaza",
                        "selectImageTitle": "Select an Image",
                        "selectAnotherTitle": "Select Another",
                        "controlsBackground": "#244C9D",
                        "backgroundColorBtn": "black",
                        "reUpload": true,
                        "tokenName": "token"
                      }
                    },
                    {
                      "fieldType": "empty-bucket",
                      "properties": {
                        "grid": {
                          "columns": 7
                        },
                        "fields": [
                          {
                            "fieldType": "receipt-information",
                            "fieldId": "5mq1p6",
                            "properties": {
                              "grid": {
                                "alignItems": "center",
                                "justifyContent": "center",
                                "columns": "12"
                              },
                              "styles": {
                                "text-align": "left"
                              },
                              "color": "#DB0811",
                              "textColor": "#141414",
                              "descriptionTextColor":"#00291C",
                              "descriptionText": "Nu se accepta bonuri sau facturi pliate/indoite sau scanate",
                              "receiptImage": "receipt33",
                              "receiptIsSvg": true,
                              "steps": [
                                {
                                  "text": "Nume magazin",
                                  "label": "A"
                                },
                                {
                                  "text": "Produsele participante la promotie si pretul lor",
                                  "label": "B"
                                },
                                {
                                  "text": "Suma totala a bonului/facturii in LEI/RON",
                                  "label": "C"
                                },
                                {
                                  "text": "Data si ora de pe bon sau de pe factura",
                                  "label": "D"
                                },
                                {
                                  "text": "Nr bonului fiscal/facturii",
                                  "label": "E"
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "bsbsd35",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "receipt-image-information"
              }
            ]
          },
          {
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "40px"
            },
            "container": true,
            "styles": {
              'justify-content': 'center'
            },
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "Trimite",
                  "addClass": "btn-red-gradient",
                  "shouldCheckCrop": true,
                  "requires": ["klvakj"],
                  "action": {
                    "fn": "sendReceipt",
                    "params": ""
                  }
                }
              }
            ]
          }
        ]
      },
      { // Product reupload
        "pageName": "ColgateUltra2023/product-reupload",
        "isPublic": true,
        "pageId": 1282452,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "headerWrap": true,
            "sectionId": "fu30zq",
            "fields": [
              {
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "referenceNumber",
                      state: "formData"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1>Incarca o poza a produsului</h1>",
                  styles: {
                    "color": "#0E1B17"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basv352",
                "properties": {
                  "text": "Incarca o poza cu produsele participante in campanie",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '20px;',
                    "color": "#00291C;"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basg325",
                "properties": {
                  "text": "Doar fisiere JPG, si PNG sunt acceptate. Fisierul poate avea maxim 16MB.",
                  "grid": {
                    "marginBottom": "40px"
                  },
                  styles: {
                    "font-weight": '400;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '14px;',
                    "line-height": "20px;",
                    "color": "#00291C;"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 0,
                    "justifyContent": "center",
                    "maxWidth": "1230px"
                  },
                  "fields": [
                    {
                      "fieldType": "product-upload",
                      "fieldId": "ase123v",
                      "properties": {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca poza</span><br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Fisierul poate avea maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        "colorSchema": "#244C9D",
                        "borderColor": "#244C9D",
                        "buttonClass": "btn-red-gradient-secondary",
                        "inputBacgroundColor":"#F0EEF1",
                        "grid": {
                          "columns": 5,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "endpoint": "/uploadProductPhoto",
                        "successAction": {
                          "fn": "goToPage",
                          "params": "ColgateUltra2023/Multumesc"
                        },
                        "phrases": [
                          "Chitanta dvs. este acum incarcata si procesata.",
                          "Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.",
                          "Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou."
                        ],
                        "cornerDetectionPhrases": [
                          "Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.",
                          "Te rugam sa potrivesti bonul in cadran.",
                          "Puteti sterge informatii private cu instrumentul de stergere."
                        ],
                        "reUpload": true
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "marginTop": "60px",
              "marginBottom": "30px"
            },
            "container": true,
            "styles": {
              'justify-content': 'center'
            },
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "Trimite",
                  "addClass": "btn-red-gradient",
                  "shouldCheckCrop": false,
                  "requires": ["ase123v"],
                  "action": {
                    "fn": "sendProductPhotos",
                    "params": ""
                  }
                }
              }
            ]
          }
        ]
      },
      { // Thank you
        "pageName": "ColgateUltra2023/Multumim",
        "pageId": 99800,
        "noContainer": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "thank-you",
                "fieldId": "gjd10",
                "properties": {
                  "campaign": "ColgateUltra2023",
                  "campaignName": "Campania Nationala Colgate Max White Ultra Money Back",
                  "haveActivator": false,
                  "borderColor": "rgba(86, 22, 23, 0.25)",
                  "textColor": "#0E1B17",
                  "textBeforeReferenceColor": "#828282",
                  "referenceColor": "#DB0811",
                  "copyImageSrc":"/assets/icons/copy4.svg"
                }
              }
            ]
          }
        ]
      },
      { // Thank you after reupload
        "pageName": "ColgateUltra2023/Multumesc",
        "pageId": 99801,
        "noContainer": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "thank-you",
                "fieldId": "gjd10",
                "properties": {
                  "campaign": "ColgateUltra2023",
                  "campaignName": "Campania Nationala Colgate Max White Ultra Money Back",
                  "haveActivator": false,
                  "borderColor": "rgba(86, 22, 23, 0.25)",
                  "textColor": "#0E1B17",
                  "textBeforeReferenceColor": "#828282",
                  "referenceColor": "#DB0811",
                  "copyImageSrc":"/assets/icons/copy4.svg"
                }
              }
            ]
          }
        ]
      },
      { // Error page
        "pageName": "error-page",
        "pageId": 10424,
        isPublic: true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12
            },
            "container": true,
            fields: [
              {
                "fieldType": "error-page",
                "fieldId": "gjd10",
                "properties": {
                  "grid": {
                    "columns": "12"
                  },
                  "showLottie": true,
                  "buttonClass": "btn-red-gradient",
                  "LottieUrl":"/assets/Lottie/error-Lottie-blue-bear-pink-boat.txt"
                }
              }
            ]
          }
        ]
      },
      { // Faq
        "pageName": "ColgateUltra2023/IntrebariFrecvente",
        "isPublic": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12,
              "marginBottom": "50px"
            },
            "fields": [
              {
                "fieldType": "docs-embed",
                "fieldId": "vabd69",
                "properties": {
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "12"
                  },
                  "docSource": "https://docs.google.com/document/d/e/2PACX-1vRTVc8nfNBzJ1GpDl0PGSeCY_2tdpi130zCAUE-DRSNq485_cq95Nrf6eRPr5HRoQ/pub?embedded=true"
                }
              }
            ]
          }
        ]
      },
      { // Castigatori
        "pageName": "ColgateUltra2023/castigatori",
        "isPublic": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12,
              "marginBottom": "50px"
            },
            "fields": [
              {
                "fieldType": "text-list",
                "fieldId": "a6prst",
                "properties": {
                  "colorSchema": "#002923",
                  "title": "Castigatori",
                  "ordered": false,
                  "items": [
                    // {
                    //   title: `1 x Pachet Servicii de înfrumusețare /
                    //   SPA timp de un an de zile`,
                    //   text: `
                    //   <ul>
                    //     <li>Roșu Viorica</li>
                    //   </ul>`
                    // }
                  ],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "8"
                  }
                }
              }
            ]
          }
        ]
      }
    ],
    "header": {
      "fieldType": "navbar",
      "fieldId": "cbx34t",
      "properties": {
        "dataLayer": {
          "GTM": {
            "Sitelocale": "ro-ro",
            "SiteTouchpoint": "",
            "SiteCountry": "RO",
            "SiteBrand": "",
            "SiteLanguage": "RO",
            "SitePlatform": "",
            "SiteEnvironment": "Prod",
            "SiteHost": "CTL",
            "SiteTechnicalAgency": "Justsnap",
            "SiteStatus": "Live",
            "GoogleAnalyticsLocal": "UA-15274544-47",
            "GoogleAnalyticsBrand": "",
            "GoogleAnalyticsSiteSpeedSampleRate": "high",
            "GoogleAnalyticsAllowLinker": "true",
            "GoogleAnalyticsLinkerDomains": "",
            "GoogleAnalyticsEnableOptimizely": "false",
            "GoogleAnalyticsConsentRequired": "true",
            "GoogleAnalyticsOptimizeContainerID": "",
            "GoogleAnalyticsReportingView": "",
            "GoogleReCaptcha": "true",
            "SiteLocalContainer": "",
            "FacebookRemarketingID": "270266680523196",
            "ConsentOverlay": "OneTrust",
            "ConsentOverlayID": "htmllang/7bfbeeed-fe9a-477f-99c7-84ca45614eb3-test",
            "SitePrivacyProtection": "GDPR"
          },
          "GTM_CODE": "GTM-TG4C5LV"
        },
        // "neustar": {
        //   "url": "https://aa.agkn.com/adscores/g.js?sid=9212300878"
        // },
        // "facebookPixel": {
        //   init: "270266680523196"
        // },
        "title": "",
        "color": "#FAF6EE",
        "grid": {
          "columns": 12
        },
        "logo": {
          "imageSource": "/assets/logo.svg",
          "width": 345,
          "alternateText": "Brand Logo",
          "paddingTop": "30px"
        },
        "fields": [
          // {
          //   "fieldId": "bsdb35",
          //   "fieldType": "anchor",
          //   "properties": {
          //     "text": "Castigatori",
          //     "url": "/ColgateUltra2023/castigatori",
          //     "target": "_blank",
          //     "cssClass": "nav-link",
          //     "styles": {
          //       "color": "#050E23",
          //       "fontSize": "18px",
          //       "fontWeight": "400"
          //     }
          //   }
          // },
          {
            "fieldId": "ikz8vc",
            "fieldType": "anchor",
            "properties": {
              "text": "Regulament",
              "url": "/files/ColgateUltra2023Regulament.pdf",
              "target": "_blank",
              "cssClass": "nav-link",
              "styles": {
                "color": "#050E23",
                "fontSize": "18px",
                "fontWeight": "400"
              }
            }
          },
          {
            "fieldId": "slnmdk",
            "fieldType": "anchor",
            "properties": {
              "text": "Intrebari frecvente",
              "url": "/ColgateUltra2023/IntrebariFrecvente",
              "target": "_blank",
              "cssClass": "nav-link",
              "styles": {
                "color": "#050E23",
                "fontSize": "18px",
                "fontWeight": "400"
              }
            }
          }
        ],
        "showLine": false,
        "meta": [
          { "name": "title", "content": "Protex" },
          {
            "name": "description",
            "content": `Protex`
          },
          {
            "name": "keywords",
            "content": `Protex`
          }
        ]
      }
    },
    "footer": {
      "fieldType": "footer-component",
      "fieldId": "4tfbzz",
      "properties": {
        "links": [
          { "name": "", "link": "" }
        ],
        "supportLinks": [
          { "name": "Confidentialitate", "link": "https://www.jnjconsumer.ro/politica-confidentialitate" }
        ],
        "styles": {
          "color": "#000"
        },
        "fields": [
          {
            "fieldId": "ikz8vc1",
            "fieldType": "anchor",
            "properties": {
              "text": "Termeni si conditii",
              "url": "/files/ColgateUltra2023Regulament.pdf",
              "target": "_blank",
              "styles": {
                "color": "#40454A"
              }
            }
          },
          {
            "fieldId": "slnmdk2",
            "fieldType": "anchor",
            "properties": {
              "text": " Politica de confidentialitate",
              "url": "https://www.colgatepalmolive.ro/legal-privacy-policy/privacy-policy",
              "target": "_blank",
              "styles": {
                "color": "#40454A"
              }
            }
          }
        ]
      }
    },
    "campaignId": "colgateultra-mb-2023",
    "url": "https://promocolgatepalmolive.ro/",
    "name": "colgateultra-mb-2023"
  },
  pageBuilder: {
    selectedField: {
      sectionId: '',
      fieldId: generateUID()
    }
  },
  componentStatus: {},
  modal: {
    type: 'error',
    message: 'An error has occurred',
    isActive: false
  },
  customerToken: '',
  receiptToken: '',
  receiptImage: '',
  campaignId: 'colgateultra-mb-2023',
  formData: new FormData(),
  campaignStartDate: "2023-07-15",
  campaignEndDate: "2023-08-31",
  showNavLinks: false,
  excludedPages: ['home'],
  cities: []
}
